import { Switch, Route, useRouteMatch, Redirect, useHistory } from 'react-router-dom';
import { useState, useContext } from 'react';
import { getClDomain } from '../../utils/Common';
// provider
import ModalProvider from "../../contexts/modal/Provider";
// contexts
import AuthContext from '../../contexts/auth';
import SidebarContext from "../../contexts/sidebar";
// components
import Spinner from '../../components/Spinner';
import UserProfile from './UserProfile';
import Home from './Home';

import './index.css';


import { verifyAccessViewPermissions } from '../../config/permissions';
import OpenCloseCash from './Cash/OpenClose';
import CashMangement from './Cash/Management';
import DailyReport from './Cash/Report';
import SearchDailyReport from './Cash/SearchReport';
import RegisterRemittances from './Remittances/Register';
import SearchRemittances from './Remittances/Search';
import DeliverRemittances from './Remittances/Deliver';
import PostOfficeManagement from './PostOffices/Management';
import SearchAlerts from './Alerts/SearchAlerts';
import SearchPostOffices from './PostOffices/Search';
import SearchCommissionReport from './PostOffices/SearchReport';
import SearchCashBox from './Cash/Search';
import AllPostOffices from './Administration/PostOffices';
import CreatePostOffice from './Administration/PostOffices/CreatePostOffice';
import AllClients from './Administration/Clients';
import CreateClient from './Administration/Clients/CreateClient';
import Requests from './Requests';
import Deposits from './Deposits';

// import CreatePlatform from './Platforms/CreatePlatform'

const Dashboard = () => {
	const userContext = useContext(AuthContext);
	const sidebarContext = useContext(SidebarContext);
    let { url } = useRouteMatch();
	const history = useHistory();
	const [update, setUpdate] = useState(false);

	const updateSidebarInfo = () => setUpdate(!update);

    // CAMBIO TEMPORAL - CORREOS PA
	// if (!sessionStorage.getItem('token') && userContext.loading) {
	// 	return  <div className="loader center">
	// 			<Spinner type={0} size={40}/>
	// 			</div>
	// }
	// if (!userContext.loading && userContext.user === null) history.push('/');

	return (
	<>
    	<div 
            id='mainLayout'
            className={"main-layout" + (sidebarContext.sidebarOpen ? "-open" : "")} 
            style={ getClDomain() !== 'cotel.myboxit.com' ? { top: '82px', height: 'calc(100% - 82px)' } : { top: '60px', height: 'calc(100% - 60px)' } }
            onClick={ () => (sidebarContext.isMobile && sidebarContext.sidebarOpen) ? sidebarContext.closeSidebar() : null } >
            <ModalProvider>
                <Switch>
                    <Route path={`${url}`} component={Home} exact />
                  
                     <Route path={`${url}/profile`} exact>
                        <UserProfile updateSidebarInfo={updateSidebarInfo} />
                    </Route> 
                    
                    {verifyAccessViewPermissions(["view_cashbox_open_close"]) &&
                        <Route path={`${url}/cash/openclose`} exact>
                        <OpenCloseCash />
                    </Route>
                    }

                    {verifyAccessViewPermissions(["view_cashbox_management"]) &&
                        <Route path={`${url}/cash/management`} exact>
                        <CashMangement />
                    </Route>
                    }

                    {verifyAccessViewPermissions(["view_cashbox_search"]) &&
                        <Route path={`${url}/cash/search`} exact>
                        <SearchCashBox />
                    </Route>
                    }

                    {verifyAccessViewPermissions(["view_cashbox_daily_report"]) &&
                        <Route path={`${url}/cash/dailyReport`} exact>
                        <DailyReport />
                    </Route>
                    }

                    {verifyAccessViewPermissions(["view_cashbox_search_daily_report"]) &&
                        <Route path={`${url}/cash/dailyReport/search`} exact>
                        <SearchDailyReport />
                    </Route>
                    }


                    {verifyAccessViewPermissions(["view_remittances_new"]) &&
                         <Route path={`${url}/remittances/new`} exact>
                         <RegisterRemittances />
                     </Route>
                    }
               
                    {verifyAccessViewPermissions(["view_remittances_search"]) &&
                     <Route path={`${url}/remittances/search`} exact>
                     <SearchRemittances />
                    </Route>
                    }
                   
                    {verifyAccessViewPermissions(["view_remittances_deliver"]) &&
                       <Route path={`${url}/remittances/deliver`} exact>
                       <DeliverRemittances />
                   </Route>
                    }

                    {verifyAccessViewPermissions(["view_postoffice_management"]) &&
                        <Route path={`${url}/postoffice/management`} exact>
                        <PostOfficeManagement />
                    </Route>
                    
                    }

                    {verifyAccessViewPermissions(["view_postoffice_search"]) &&
                        <Route path={`${url}/postoffice/search`} exact>
                        <SearchPostOffices />
                    </Route>
                    }

                    {verifyAccessViewPermissions(["view_postoffice_search_report"]) &&
                        <Route path={`${url}/postoffice/report/search`} exact>
                        <SearchCommissionReport />
                    </Route>
                    }

                    {verifyAccessViewPermissions(["view_search_alerts"]) &&
                        <Route path={`${url}/alerts/search`} exact>
                        <SearchAlerts />
                    </Route>
                    }

                    {verifyAccessViewPermissions(["view_admin_postoffices"]) &&
                        <Route path={`${url}/administration/postoffices`} exact>
                        <AllPostOffices />
                    </Route>
                    }

                    {verifyAccessViewPermissions(["view_admin_create_postoffice"]) &&
                        <Route path={`${url}/administration/create/postoffice`} exact>
                        <CreatePostOffice />
                    </Route>
                    }

                    {verifyAccessViewPermissions(["view_admin_users"]) &&
                        <Route path={`${url}/administration/users`} exact>
                        <AllClients />
                    </Route>
                    }

                    {verifyAccessViewPermissions(["view_admin_create_user"]) &&
                        <Route path={`${url}/administration/create/user`} exact>
                        <CreateClient />
                    </Route>
                    }

                    {verifyAccessViewPermissions(["view_requests_management"]) &&
                        <Route path={`${url}/requests/management`} exact>
                        <Requests />
                    </Route>
                    }

                    {verifyAccessViewPermissions(["view_deposits_new"]) &&
                        <Route path={`${url}/deposits/new`} exact>
                        <Deposits />
                    </Route>
                    }

           

                  
                 
                    <Redirect from={`${url}/*`} to={`${url}/`} />
                </Switch>
            </ModalProvider>
        </div>
    </>
	);
};

export default Dashboard;
